<template>
    <div class="list-position-tags" v-if="position && position.positionTags">
      <div v-if="!xiaolie">
        <span v-for="(item , index) in position.positionTags" :key="index" :class="'icon-tag ' + item.tagStyleClass">{{item.tagDispalyName}}</span>
      </div>
      <div v-if="xiaolie" class="icon-tag-xiaolie-wrap">
        <span :class="'icon-tag ' + xiaolie.tagStyleClass">{{xiaolie.tagDispalyName}}</span>
        <span class="icon-tag-xiaolie-desc" v-html="xiaolieDes"></span>
      </div>
    </div>
</template>

<script>
  export default {
    props: {
        position: {}
    },
    data() {
      return {
        tags:[],
        xiaolie:null,
        xiaolieDes:null
      }
    },
    watch:{
      position(){
        
      }
    },
    methods:{
      checkTag(){

      }
    },
    created(){
      if(this.position && this.position.positionTags && this.position.positionTags.length){
        this.position.positionTags.forEach((cols, index) => {
          if(cols.tagId == '463095885486845953'){
            this.xiaolie = cols;
            this.xiaolieDes = cols.tagShowMessage.split('，')[0];
          };
        });
      }
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .list-position-tags {
        width: 100%;
        overflow: hidden;
        display: flex;
        margin: 5px 0;
        flex-wrap: wrap;
        span {
          margin-bottom:5px;
        }
        .icon-tag:first-child {
            margin-left: 0;
        }
    }
</style>
